export enum CommissionType {
  Percent = 'percent',
  Amount = 'amount'
}

export const CommissionTypeLabel = (value: CommissionType | string): string => {
  switch (value) {
    case CommissionType.Amount:
      return '$';
    default:
      return '%';
  }
};
